import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
const _sfc_main = {
  name: "LogoReduced"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { staticClass: "reducedLogo", attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 121 64" } }, [_c("path", { attrs: { "d": "M71.09 0H60.696v62.726h10.392V0ZM33.256 11.581c6.926 0 11.304 1.367 17.689 3.923L56.14 6.84C50.49 3.467 42.737.726 33.163.726 13.104.726.526 12.948.526 32.366.526 51.787 13.104 64 33.163 64c9.575 0 17.32-2.733 22.978-6.107l-5.196-8.663c-6.385 2.548-10.756 3.922-17.689 3.922-13.311 0-21.426-7.845-21.426-20.785 0-12.941 8.115-20.786 21.426-20.786ZM88.686 0H78.293v62.726h10.393V0Zm11.673 25.07c-5.288 3.922-8.57 7.93-8.57 14.863s3.282 10.848 8.478 14.77c3.281 2.463 7.381 4.834 11.852 8.023h8.57V56.07L98.445 41.3c-.456-.363-.734-.819-.734-1.367s.27-1.096.734-1.366l22.244-14.863V17.14h-8.57c-4.471 3.096-8.478 5.467-11.76 7.93Z" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null
);
const LogoReduced = __component__.exports;
export {
  LogoReduced as default
};
